import { useRef } from 'react'

import _ from 'lodash'
import CountUp from 'react-countup'

import { withResourceRecord } from '@/shared/contexts'
import { useRecord, useResourceRecordContext } from '@/shared/hooks'
import { Card } from '@/shared/ui'
import { AppIcon  } from '@/shared/ui/icons'

import { getConfig } from './config'

const AnalyticsIndicator = indicator => {
  const iconRef = useRef(null)

  const handleUpdate = () => {
    iconRef.current?.classList.add(
      'icon-beat',
      `text-${indicator?.variant || 'success'}`
    )

    setTimeout(() => {
      iconRef.current?.classList.remove(
        'icon-beat',
        `text-${indicator?.variant || 'success'}`
      )
    }, 2000)
  }

  return (
    <Card className="h-full">
      <Card.Body className="flex flex-col p-10">
        <div className="mb-6 relative text-gray-600">
          <span ref={iconRef} className="inline-flex">
            <AppIcon
              name={indicator.icon}
              size={48}
              variant="duotone"
            />
          </span>
        </div>
        <span className="font-semibold text-4xl text-dark leading-none block mb-2">
          <CountUp
            end={indicator.value || 0}
            preserveValue
            onUpdate={handleUpdate}
          />
        </span>
        <span className="font-semibold text-base text-gray-500 mt-auto">
          {indicator.name}
        </span>
      </Card.Body>
    </Card>
  )
}

export const DigitalProductAnalytics = withResourceRecord(
  ({ digitalProductId }) => {
    const { record: digitalProduct } = useRecord({
      r: '/public/digital_products',
      id: digitalProductId,
      options: {
        retry: 10,
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchInterval: 30000
      }
    })
    const { record: analytics } = useResourceRecordContext()

    const indicators = [
      {
        slug: 'users',
        name: 'Participantes da Gamificação',
        icon: 'user-bounty-hunter',
        variant: 'primary',
        value: analytics?.gamification_participants
      },
      {
        slug: 'adventures',
        name: 'Aventureiros(as) das Jornadas',
        icon: 'person-hiking',
        variant: 'primary',
        value: analytics?.started_a_journey_participants
      },
      {
        slug: 'missions',
        name: 'Pessoas que cumpriram Missões',
        icon: 'flag',
        variant: 'primary',
        value: analytics?.finished_missions_participants
      },
      {
        slug: 'moment',
        name: 'Participantes do Momentos GO!RN',
        icon: 'stars',
        variant: 'warning',
        value: analytics?.finished_go_moment_mission_participants
      },
      {
        slug: 'lectures-interactions',
        name: 'Interações com palestras e correalizadores',
        icon: 'podium-star',
        variant: 'info',
        value: analytics?.interactions_size
      },
      {
        slug: 'food',
        name: (
          <>
            KG de alimentos arrecadados no <br />
            <span className="text-gray-600">GO! Solidariedade</span>
          </>
        ),
        icon: 'pot-food',
        variant: 'danger',
        value: _.get(digitalProduct, 'gamification_meta.analytics.food', 0)
      },
      {
        slug: 'cloth',
        name: (
          <>
            Peças de roupas arrecadadas no <br />
            <span className="text-gray-600">GO! Solidariedade</span>
          </>
        ),
        icon: 'shirt',
        variant: 'dark',

        value: _.get(digitalProduct, 'gamification_meta.analytics.cloth', 0)
      }
    ]

    return (
      <div className="container h-screen flex flex-col items-center justify-center">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 justify-items-center">
          <div>
            <Card className="h-full">
              <Card.Body className="flex flex-col items-center justify-center p-10">
                <img
                  id="logo"
                  alt="Logo"
                  src={
                    _.get(digitalProduct, 'logo.file.url') ||
                    '/logo-dark-alt.png'
                  }
                  className="h-[75px] lg:h-[100px] xl:h-[125px]"
                />
              </Card.Body>
            </Card>
          </div>
          {indicators.map(indicator => (
            <div key={indicator.slug}>
              <AnalyticsIndicator {...indicator} />
            </div>
          ))}
        </div>
      </div>
    )
  },
  getConfig
)
